import { useQuery } from '@tanstack/react-query'

import { QUERY_KEY_MARKETING_SOURCES } from '../../types/constants'
import { authenticatedApi } from '../../utils/api'

async function getMarketingSources() {
  return authenticatedApi.get(`marketing-source`).json<any[]>()
}

export const useMarketingSources = ({ freezeCache }: { freezeCache?: boolean } = {}) => {
  return useQuery({
    queryKey: [QUERY_KEY_MARKETING_SOURCES],
    queryFn: () => getMarketingSources(),
    staleTime: freezeCache ? Infinity : undefined,
    refetchOnWindowFocus: false,
    refetchOnMount: freezeCache ? false : undefined,
    refetchOnReconnect: freezeCache ? false : undefined,
  })
}
